export default "__VITE_ASSET__8807f3a4__"